mpangoApp.factory('Mevent',['$http', function($http) {
	return{
		getEvent : function() {
			return $http.get('index.php/api/getevent');
		},
		postEvent : function(eventdata) {
			return $http({
				method: 'POST',
				url: 'index.php/api/postevent',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':eventdata}
			
			});
		},
		updateEvent : function(eventdata,formname) {
			return $http({
				method: 'POST',
				url: 'index.php/api/updateevent',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':eventdata, 'formname':formname}
			
			});
		},
	}
}]);